import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import HomeSlider from "./components/Slider";
import ServicesSection from "./components/ServicesSection";
import About from "./components/About";
import StudentReservationPolicy from "./components/StudentReservationPolicy";
import Facilities from "./components/Facilities";
import Activities from "./components/Activities";
import Gallery from "./components/Gallery";
import AdmissionSection from "./components/AdmissionSection";
import Footer from "./components/Footer";
import EventsSection from "./components/EventsSection";

import '@fortawesome/fontawesome-free/css/all.min.css';

// Debug component
const RouteDebugger = () => {
  const location = useLocation();
  useEffect(() => {
    console.log("Current route:", location.pathname);
  }, [location]);
  return null;
};

// Loading component
const Loading = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh'
  }}>
    <div>Loading...</div>
  </div>
);

// 404 Page
const NotFound = () => (
  <div style={{
    padding: '100px 20px',
    textAlign: 'center',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f9f9f9'
  }}>
    <h1 style={{
      color: '#7c1c1b',
      marginBottom: '20px',
      fontSize: '2.5rem'
    }}>404 - Page Not Found</h1>
    <p style={{
      marginBottom: '30px',
      fontSize: '1.2rem',
      color: '#666'
    }}>
      The page you are looking for does not exist.
    </p>
    <a
      href="/"
      style={{
        padding: '12px 30px',
        backgroundColor: '#7c1c1b',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        fontWeight: '600',
        fontSize: '1rem',
        transition: 'background-color 0.3s'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#5a1514'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#7c1c1b'}
    >
      Return to Homepage
    </a>
  </div>
);

// Lazy pages
const LazyAboutus = React.lazy(() => import("./pages/Aboutus"));
const LazyFacilitiesPage = React.lazy(() => import("./pages/FacilitiesPage"));
const LazyActivitiesPage = React.lazy(() => import("./pages/ActivitiesPage"));
const LazyContactPage = React.lazy(() => import("./pages/ContactPage"));
const LazyAllEventsPage = React.lazy(() => import("./components/AllEventsPage"));
const LazyCongregation = React.lazy(() => import("./pages/about/Congregation"));
const LazyManagement = React.lazy(() => import("./pages/about/Management"));
const LazyFaculty = React.lazy(() => import("./pages/about/Faculty"));

const LazyParentHospital = React.lazy(() => import("./pages/about/ParentHospital"));
const LazyPlacement = React.lazy(() => import("./pages/about/Placement"));
const LazyTraining = React.lazy(() => import("./pages/about/Training"));


const LazyBscnursing = React.lazy(() => import("./pages/courses/BscNursing"));
const LazyDgnm = React.lazy(() => import("./pages/courses/DGNM"));


const LazyLabs = React.lazy(() => import("./pages/facilities/Labs"));
const LazyAcademic = React.lazy(() => import("./pages/facilities/Academic"));
const LazyHostel = React.lazy(() => import("./pages/facilities/Hostel"));
const LazyTransport = React.lazy(() => import("./pages/facilities/Transport"));


// Placeholder components for subpages
const Placeholder = ({ title }) => (
  <div style={{ padding: "100px 20px", textAlign: "center" }}>
    <h2>{title}</h2>
    <p>Content coming soon...</p>
  </div>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loading />;

  return (
    <Router>
      <div className="App">
        <Header />
        <RouteDebugger />
        <main>
          <React.Suspense fallback={<Loading />}>
            <Routes>
              {/* Home */}
              <Route
                path="/"
                element={
                  <>
                    <HomeSlider />
                    <ServicesSection />
                    <About />
                    <Facilities />
                    <Activities />
					<StudentReservationPolicy />
                    <Gallery />
                    <AdmissionSection />
                    <EventsSection />
                  </>
                }
              />

              {/* About Us */}
              <Route path="/aboutus" element={<LazyAboutus />} />
              <Route path="/about/congregation" element={<LazyCongregation />} />
              <Route path="/about/management" element={<LazyManagement />} />
              <Route path="/about/faculty" element={<LazyFaculty />} />
              <Route path="/about/parent-hospital" element={<LazyParentHospital/>} />
              <Route path="/about/training" element={<LazyPlacement />} />
              <Route path="/about/placement" element={<LazyTraining />} />

              {/* Courses */}
              <Route path="/courses/bsc-nursing" element={<LazyBscnursing />} />
              <Route path="/courses/dgnm" element={<LazyDgnm />} />

              {/* Facilities */}
              <Route path="/facilities" element={<LazyFacilitiesPage />} />
              <Route path="/facilities/labs" element={<LazyLabs />} />
              <Route path="/facilities/academic" element={<LazyAcademic />} />
              <Route path="/facilities/hostel" element={<LazyHostel />} />
              <Route path="/facilities/transport" element={<LazyTransport />} />

              {/* Activities */}
              <Route path="/activities" element={<LazyActivitiesPage />} />
              <Route path="/activities/developmental" element={<Placeholder title="Developmental Activities" />} />
              <Route path="/activities/academical" element={<Placeholder title="Academical Activities" />} />
              <Route path="/activities/health-education" element={<Placeholder title="Health Education" />} />

              {/* Extracurricular */}
              <Route path="/extracurricular/faculty" element={<Placeholder title="Extracurricular - Faculty" />} />
              <Route path="/extracurricular/students" element={<Placeholder title="Extracurricular - Students" />} />

              {/* Others */}
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/news-events" element={<LazyAllEventsPage />} />
              <Route path="/alumni" element={<Placeholder title="Alumni" />} />
              <Route path="/contact" element={<LazyContactPage />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </React.Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
